import { FC, useEffect, useState } from "react";
import styles from "./AdminPanel.module.scss";
import { Input } from "../ui/Input/Input";
import {
  IClub,
  IClubCreate,
  IClubEdite,
  IResponseGetClubs,
  TClubId,
} from "../../types/club";
import {
  addClub,
  deleteClubs,
  editeClub,
  getClubs,
  getDeletedClubs,
  getRestoreClubs,
} from "../../api/clubs";
import { ErrorPage } from "../../pages/ErrorPage/ErrorPage";
import Loader from "../Loader/Loader";
import deleteIcon from "../../images/icons/delete.svg";
import ImageUploader from "../ui/ImageUploader/ImageUploader";
import { Button } from "../ui";
import returnIcon from "../../images/icons/undo.svg";
import pencil from "../../images/icons/Vector.svg";

export const AdminClubs: FC<{ isDelete?: boolean }> = ({ isDelete }) => {
  const [idClub, setIdClub] = useState(-1);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [website, setWebsite] = useState("");
  const [address, setAddress] = useState("");
  const [clubs, setClubs] = useState<IClub[]>([]);
  const [clubsIsDelete, setClubsIsDelete] = useState<IClub[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [images, setImages] = useState<string[]>([]);
  const [buttonName, setButtonName] = useState("Add");

  async function fetchData() {
    try {
      setIsLoading(true);
      const data: IResponseGetClubs = await getClubs();
      setClubs(data.data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchDataDelete() {
    try {
      setIsLoading(true);
      const data: IResponseGetClubs = await getDeletedClubs();
      setClubsIsDelete(data.data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
    fetchDataDelete();
  }, []);

  async function handleDelete(id: number) {
    try {
      setIsLoading(true);
      await deleteClubs(id);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
      fetchData();
    }
  }

  async function handlerClub() {
    if (buttonName === "Add") {
      try {
        setIsLoading(true);

        const club: IClubCreate = {
          club: name,
          description: description,
          address: address,
          website: website,
          photos: images && images.length > 0 ? images : null,
        };
        await addClub(club);
        fetchData();
      } catch {
        return <ErrorPage />;
      } finally {
        setName("");
        setDescription("");
        setAddress("");
        setWebsite("");
        setImages([]);
        setIsLoading(false);
      }
    } else {
      try {
        setIsLoading(true);
        const club: IClubEdite = {
          club: name,
          description: description,
          address: address,
          website: website,
          photos: images && images.length > 0 ? images : null,
        };
        await editeClub(club, idClub);
        fetchData();
      } catch {
        return <ErrorPage />;
      } finally {
        setName("");
        setDescription("");
        setAddress("");
        setWebsite("");
        setImages([]);
        setIsLoading(false);
        setIdClub(-1);
      }
    }
  }

  const handleImageRemove = (image: string) => {
    setImages((prev) =>
      prev.includes(image)
        ? prev.filter((img) => img !== image)
        : [...prev, image],
    );
  };

  async function handleRestore(id: number) {
    try {
      setIsLoading(true);
      const service = {
        clubId: id,
      };
      await getRestoreClubs(service);
      fetchDataDelete();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  const handleEdite = (club: IClub) => {
    setAddress(club.address);
    setDescription(club.description);
    setName(club.club);
    setWebsite(club.website);
    setImages(club.clubsPhotos.map((item) => item.photoUrl));
    setButtonName("Redigieren");
    setIdClub(club.id);
  };

  if (isLoading)
    return (
      <div className={styles.loader}>
        <Loader color="#ac2386" size={60} borderWidth={5} />
      </div>
    );

  return (
    <div className={styles.container}>
      {isDelete === false && (
        <div className={styles.block}>
          <div className={styles.block_old}>
            <ul className={styles.parametr}>
              {clubs &&
                clubs.map((club) => (
                  <li className={styles.block_old_item} key={club.id}>
                    <p className={styles.block_old_description}>{club.club}</p>
                    <img
                      className={styles.block_old_icon}
                      src={pencil}
                      alt="Icon edite"
                      onClick={() => handleEdite(club)}
                    />
                    <img
                      className={styles.block_old_icon}
                      src={deleteIcon}
                      alt="Icon delete"
                      onClick={() => handleDelete(club.id)}
                    />
                  </li>
                ))}
            </ul>
          </div>
          <div className={styles.block_club}>
            <Input
              label={"Titel"}
              type={"text"}
              id={""}
              placeholder={"Titel..."}
              value={name}
              setValue={setName}
            />
            <Input
              label={"Website"}
              type={"text"}
              id={""}
              placeholder={"Website..."}
              value={website}
              setValue={setWebsite}
            />
            <Input
              label={"Adresse"}
              type={"text"}
              id={""}
              placeholder={"Adresse..."}
              value={address}
              setValue={setAddress}
            />
            <div className={styles.textareaBlock}>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Beschreibung</label>
                <textarea
                  placeholder="Enter beschreibung..."
                  value={description}
                  className={styles.textarea}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
            <ImageUploader
              images={images}
              setImage={setImages}
              handleImageRemove={(img) => handleImageRemove(img)}
            />
            <div className={styles.Button}>
              <Button onClick={handlerClub}>{buttonName}</Button>
            </div>
          </div>
        </div>
      )}
      {isDelete === true &&
        (clubsIsDelete && clubsIsDelete.length > 0 ? (
          clubsIsDelete.map((club) => (
            <li className={styles.block_old_item} key={club.id}>
              <p className={styles.block_old_description}>{club.club}</p>
              <img
                className={styles.block_old_icon}
                src={returnIcon}
                alt="Icon delete"
                onClick={() => handleRestore(club.id)}
              />
            </li>
          ))
        ) : (
          <p>Es gibt keine entfernten Clubs</p>
        ))}
    </div>
  );
};
